<div class="boxWrap">
  <div class="estimate_wrap d_flex align_center">
    <div class="roundedRectangleBox box_1">
      <span class="location_icon"></span>
      <!-- <img src="../../../assets/icons/location_icon.svg" alt="location_pin_icon"> -->
      <span class="address_text textTitle">
        {{historyState.address}}
      </span>
    </div>
    <div class="roundedRectangleBox box_2" *ngIf="historyState.ListPrice">
      <span class="price_icon"></span>
      <!-- <img src="../../../assets/icons/list_price_icon.svg" alt="location_pin_icon"> -->
      <p>
        <span class="textTitle">List Price:</span>
        <span class="contentValue"> ${{historyState.ListPrice | number}}</span>
      </p>
    </div>
    <div class="roundedRectangleBox box_3" *ngIf="historyState.maxSavings">
      <span class="estimate_icon ht"></span>
      <!-- <img src="../../../assets/icons/estimate_icon.svg" alt="money_icon"> -->
      <p>
        <span class="textTitle">Your Estimated Savings:</span>
        <span class="contentValue"> ${{historyState.minSavings | number}} -
          ${{historyState.maxSavings | number}}</span>
      </p>

    </div>
    <div class="roundedRectangleBox box_4" *ngIf="historyState.OnMarketDate">
      <span class="calendar_icon"></span>
      <!-- <img src="../../../assets/icons/calendar_icon.svg" alt="money_icon"> -->
      <p>
        <span class="textTitle">List Date:</span>
        <span class="contentValue"> {{historyState.OnMarketDate | date}}</span>
      </p>
    </div>
  </div>
  <div class="formButtons" *ngIf="!historyState.hideContinue">
    <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>

    <button *ngIf="!isLoader && showBack==true" (click)="backButtonOnClick()" class="arrowBtn leftArrow">
      <img src="../../../assets/icons/arrow_left_grey.svg" alt="arrow_left">
    </button>
    <button *ngIf="!isLoader && showForward==true" (click)="forwardOnClick()" class="arrowBtn rightArrow">
      <img src="../../../assets/icons/arrow_right_grey.svg" alt="arrow-right">
    </button>
    <button *ngIf="!isLoader && showSubmitBtn==true" class="submitBtn"
      (click)="submitBtnonClick()">{{submitBtnLabel}}</button>
  </div>


  <!-- mobile scetion -->
  <div class="w_100 mobileDropWrap">
    <div class="roundedRectangleBox responsiveDrop" *ngIf="historyState.maxSavings">
      <div class="d_flex" style="justify-content: space-between;">
        <div class="d_flex" style="gap: 12px;">
          <span class="estimate_icon"></span>
          <!-- <img src="../../../assets/icons/estimate_icon.svg" alt="money_icon"> -->
          <p class="estimatSaving">
            <span class="textTitle">Your Estimated Savings:</span>
            <span class="contentValue"> ${{historyState.minSavings | number}} -
              ${{historyState.maxSavings | number}}</span>
          </p>
        </div>
        <button (click)="toggleResClick()"><i class="fa-solid fa-chevron-down"></i></button>
      </div>
    </div>

    <div *ngIf="showResList" class="responseListItem">
      <div class="roundedRectangleBox">
        <span class="location_icon"></span>
        <!-- <img src="../../../assets/icons/location_icon.svg" alt="location_pin_icon"> -->
        <span class="address_text textTitle">
          {{historyState.address}}
        </span>
      </div>
      <div class="roundedRectangleBox" *ngIf="historyState.ListPrice">
        <!-- <img src="../../../assets/icons/list_price_icon.svg" class="price_icon" alt="location_pin_icon"> -->
        <span class="price_icon"></span>
        <p>
          <span class="textTitle">List Price:</span>
          <span class="contentValue"> ${{historyState.ListPrice | number}}</span>
        </p>
      </div>
      <div class="roundedRectangleBox" *ngIf="historyState.OnMarketDate">
        <!-- <img src="../../../assets/icons/calendar_icon.svg" alt="money_icon"> -->
        <span class="calendar_icon"></span>
        <p>
          <span class="textTitle">List Date:</span>
          <span class="contentValue">{{historyState.OnMarketDate | date}}</span>
        </p>
      </div>
    </div>
  </div>
</div>
<div class="mobile_submitButtons">
  <div class="action-btn">
    <button *ngIf="!isLoader" class="submitBtn" (click)="submitBtnonClick()">{{submitBtnLabel}}</button>
    <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>
  </div>
</div>